import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon, Popconfirm, Table } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as channelController from '../../../../../../services/api/channel';

const PUBLIC_URL = process.env.PUBLIC_URL;

export class ChannelList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSource: [],
            filteredDataSource: [],
            selectedRowKeys: []
        }
    }

    filterData() {
        const { filters, searchText } = this.props;
        const { dataSource } = this.state;

        let newDataSource = _.filter(dataSource, _.pickBy(filters, _.identity));
        newDataSource = _.filter(newDataSource, (record) => _.filter(_.map(_.values(record), (value) => value ? value.toString().toUpperCase() : ''), (value) => value.indexOf(searchText.toUpperCase()) !== -1).length !== 0);

        this.setState({ filteredDataSource: newDataSource });
    }

    fetchData() {
        channelController.getChannels()
            .then((res) => res.json())
            .then((json) => {
                const dataSource = _.map(json, (record) => ({ ...record,
                    source: record.source ? record.source.name : '',
                    type: record.type ? record.type.name : ''
                }));
                this.setState({ dataSource });
            })
            .catch((err) => console.log(err))
    }

    handleRemove() {
        const { selectedRowKeys } = this.state;

        this.setState({ isLoading: true });

        channelController.deleteChannels(selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
            })
            .catch((err) => console.log(err))
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        const { filters, searchText } = this.props;

        if (!_.isEqual(filters, prevProps.filters) || searchText !== prevProps.searchText) {
            this.filterData();
        }
    }

    renderExpandedTable(record) {
        const { ad_links } = record;
        const columns = [{
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (text, record) => <a href={`${PUBLIC_URL}/enquiry?code=${text}`}>{text}</a>
        }, {
            title: 'Enquiry Type',
            dataIndex: 'enquiry_type',
            key: 'enquiry_type',
        }, {
            title: 'Programme',
            dataIndex: 'programme',
            key: 'programme',
            render: (text, record) => text ? text.name : '--'
        }, {
            title: 'Clicked',
            dataIndex: 'clicked',
            key: 'clicked',
            align: 'center'
        }, {
            title: 'Submitted',
            dataIndex: 'submitted',
            key: 'submitted',
            align: 'center'
        }];

        if (ad_links.length !== 0) {
            return (
                <Table
                    size="small"
                    rowKey="id"
                    columns={columns}
                    dataSource={ad_links}
                    pagination={false}
                />
            )
        } else {
            return (<p style={{ textAlign: 'center', marginBottom: 0 }}>No ad-link in this channel.</p>)
        }
    }

    render() {
        const { history, filters, searchText } = this.props;
        const { dataSource, filteredDataSource, selectedRowKeys } = this.state;
        const isRowSelected = selectedRowKeys.length !== 0;
        const isFiltered = !_.isEmpty(_.pickBy(filters, _.identity)) || searchText !== '';

        const columns = [{
            title: 'Channel Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
        }, {
            title: 'Channel Type',
            dataIndex: 'type',
            key: 'type',
            sorter: (a, b) => a.type.localeCompare(b.type),
        }, {
            title: 'Channel Source',
            dataIndex: 'source',
            key: 'source',
            sorter: (a, b) => a.source.localeCompare(b.source),
        }, {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => a.status.localeCompare(b.status),
        }, {
            title: 'Start Date',
            dataIndex: 'start_date',
            key: 'start_date',
            render: (text) => moment(text).format('YYYY-MM-DD'),
            sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
        }, {
            title: 'End Date',
            dataIndex: 'end_date',
            key: 'end_date',
            render: (text) => moment(text).format('YYYY-MM-DD'),
            sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
        }, {
            title: '',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            render: (text, record) => (<Icon className="icon-btn" type="edit" onClick={() => history.push(`/dashboard/admin/channel/${record.id}`)} />)
        }];

        return (
            <div className="DataList">
                <div className="table-btn-gp">
                    <div className="table-btn-gp-left">
                        <button onClick={(e) => history.push('/dashboard/admin/channel/new')}>
                            <Icon type="plus"/>
                            Create
                        </button>
                    </div>
                    <div className="table-btn-gp-right">
                        <Popconfirm 
                            placement="bottom"
                            title="This action is irreversible, are you sure?" 
                            onConfirm={(e) => this.handleRemove()} 
                            okText="Yes" 
                            cancelText="No"
                        >
                            <button disabled={!isRowSelected}>
                                <Icon type="minus"/>
                                Remove
                            </button>
                        </Popconfirm>
                    </div>
                </div>
                <Table
                    size="small"
                    rowKey="id"
                    columns={columns}
                    dataSource={isFiltered ? filteredDataSource : dataSource}
                    rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}}
                    expandedRowRender={(record) => this.renderExpandedTable(record)}
                />
            </div>
        );
    }
}

export default withRouter(ChannelList);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ChannelPage/components/ChannelList/ChannelList.js